import { render, staticRenderFns } from "./UnpinedChat.vue?vue&type=template&id=08caa85e&scoped=true&"
import script from "./UnpinedChat.vue?vue&type=script&lang=js&"
export * from "./UnpinedChat.vue?vue&type=script&lang=js&"
import style0 from "./UnpinedChat.vue?vue&type=style&index=0&id=08caa85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08caa85e",
  null
  
)

export default component.exports